import { useDaily } from '@daily-co/daily-react';
import { Mic, MicOff, Video, VideoOff, PhoneOff, MonitorUp } from 'lucide-react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { apiClient } from '@/lib/api';

type Props = {
  isHost?: boolean;
};

export const SessionControls = ({ isHost = false }: Props) => {
  const call = useDaily();
  const navigate = useNavigate();
  const { sessionId } = useParams();
  const { getToken } = useAuth();
  const [isMicOn, setIsMicOn] = useState(true);
  const [isCamOn, setIsCamOn] = useState(true);

  const toggleMic = () => {
    call?.setLocalAudio(!isMicOn);
    setIsMicOn(!isMicOn);
  };

  const toggleCam = () => {
    call?.setLocalVideo(!isCamOn);
    setIsCamOn(!isCamOn);
  };
  //Screen Share logic with async/await
  const toggleScreen = async () => {
    try {
      const local = call?.participants().local;
      if (local?.screen) {
        await call?.stopScreenShare();
      } else {
        await call?.startScreenShare(); 
      }
    } catch (e) {
      console.error("Screenshare failed:", e);
      alert("Screenshare failed. See console for details.");
    }
  };

  const leaveSession = async () => {
    const callObject = call;

    // 1. Host Logic: Kill Session
    if (isHost && sessionId) {
      try {
        const token = await getToken();
        await apiClient.post(
          `/sessions/${sessionId}/end`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (err) {
        console.error('Failed to end session:', err);
      }
    }

    // 2. Local Cleanup (Everyone)
    if (callObject) {
      callObject.leave().catch(() => {});
      callObject.destroy().catch(() => {});
    }

    // 3. Navigate
    navigate(isHost ? '/sessions' : '/lobby');
  };

  return (
    <div className="flex gap-2 justify-center">
      <button onClick={toggleMic} className={`p-3 rounded-full text-text-primary transition-colors ${isMicOn ? 'bg-background-border hover:bg-background-border/80' : 'bg-neon-red hover:bg-neon-red/80'}`}>
        {isMicOn ? <Mic size={20} /> : <MicOff size={20} />}
      </button>
      <button onClick={toggleCam} className={`p-3 rounded-full text-text-primary transition-colors ${isCamOn ? 'bg-background-border hover:bg-background-border/80' : 'bg-neon-red hover:bg-neon-red/80'}`}>
        {isCamOn ? <Video size={20} /> : <VideoOff size={20} />}
      </button>
      <button onClick={toggleScreen} className="p-3 rounded-full bg-background-border text-text-primary hover:bg-background-border/80 transition-colors">
        <MonitorUp size={20} />
      </button>
      <button onClick={leaveSession} className="p-3 rounded-full bg-neon-red text-text-primary hover:bg-neon-red/80 transition-colors">
        <PhoneOff size={20} />
      </button>
    </div>
  );
};